module.exports = __webpack_public_path__ + "static/DIY_HeatPump_Logo-f6133e6a59836442b9ee00f986c3ffbf.svg";